import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import { Slide, Snackbar } from '@material-ui/core';

import { roles } from '../../constants';
import { dashboardService } from '../../services'
import { alertActions } from '../../modules/alert';

import OfficeCntMng from './OfficeCntMng';
import OpbItem from './OpbItem';
import SiteCntMng from './SiteCntMng';
import OpbStats from './OpbStats';
import MapContent from './MapContent';


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opbOfficeCnt: [],       // 지사별 설치 현황
            damdangOffice: "",
            siteCnt: 0,
            selectedOffice: {},     // 선택된 지사 정보

            opbSiteCnt: [],         // 현장별 설치 현황
            selectedSiteID: "",     // 선택된 현장ID

            open: false,
            text: ""
        }
    }

    componentDidMount = () => {
        this.setOpbOfficeCnt();
    }

    // 지사별 설치 현황 조회
    setOpbOfficeCnt = () => {
        const { myInfo } = this.props;
        const isAdministrator = myInfo.myRole === roles.administratorRole;

        let formData = new FormData();

        dashboardService.opbOfficeCnt(formData)
            .then(response => {
                this.setState({
                    opbOfficeCnt: response.data,
                }, () => {
                    const damdangOffice = isAdministrator ? myInfo.company.split(",")[2] : response.data[0].damdangOffice;         // 지사사용자의 지사코드 or opbOfficeCnt[0]의 지사코드
                    let siteCnt = 0;
                    this.state.opbOfficeCnt.forEach(office => {
                        if (office.damdangOffice === damdangOffice) siteCnt = office.siteCnt;
                    });
                    this.setSelectedOffice(damdangOffice, siteCnt);
                    this.handleOpen("지사별 설치 현황에서 지사를 선택하세요.");
                });
            })
            .catch(this.handleErrors);
    };

    // 현장별 설치 현황 조회
    setSelectedOffice = (damdangOffice, siteCnt) => {
        const { opbOfficeCnt } = this.state;
        const selectedOffice = opbOfficeCnt.filter(office => office.damdangOffice === damdangOffice)[0];

        let formData = new FormData();
        formData.append("damdangOffice", damdangOffice);

        dashboardService.opbSiteCnt(formData)
            .then(response => {
                this.setState({
                    damdangOffice: damdangOffice,
                    siteCnt: siteCnt,
                    selectedOffice: selectedOffice,
                    opbSiteCnt: response.data,
                    selectedSiteID: response.data.length > 0 ? response.data[0].siteID : ""
                });
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    // 지사 선택
    handleSelectedOffice = (damdangOffice, sitecnt) => {
        const { myInfo } = this.props;
        const isAdministrator = myInfo.myRole === roles.administratorRole;
        if (!isAdministrator && this.state.damdangOffice !== damdangOffice) {
            this.setSelectedOffice(damdangOffice, sitecnt);
            this.handleOpen("지도에서 현장을 선택하세요.");
        }
    };

    // 현장 선택
    handleSelectedSiteID = (siteID) => {
        this.setState({
            selectedSiteID: siteID
        });
    };

    // 스낵바 열기
    handleOpen = (text) => {
        this.setState({
            open: true,
            text: text
        });
    };
    // 스낵바 닫기
    handleClose = () => {
        this.setState({
            open: false
        });
    };



    render() {

        const { opbOfficeCnt, selectedOffice, siteCnt, opbSiteCnt, selectedSiteID, open, text } = this.state;

        return (
            <>


                {/* 대시보드 컨텐츠화면 */}
                {this.state.opbOfficeCnt.length > 0
                    ?
                    <div className="dashboard-wrapper row">
                        {/* 스낵바(알림창) */}
                        <Snackbar
                            open={open}
                            message={text}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: "top", horizontal: "center" }}
                            TransitionComponent={Slide}
                            style={{ width: "100%", top: "auto", cursor: "pointer" }}
                            ContentProps={{ style: { flexGrow: 1, flexDirection: "column", fontSize: "1.2rem" } }}
                            onClose={this.handleClose}
                            onClick={this.handleClose}
                        />

                        {/* 지사별 설치 현황 */}
                        <div className="col col-lg-2 col-12">
                            <OfficeCntMng opbOfficeCnt={opbOfficeCnt} selectedOffice={selectedOffice} handleSelectedOffice={this.handleSelectedOffice} />
                        </div>

                        {/* Display 연결 현황 및 현장별 설치 순서 */}
                        <div className="col col-lg-2 col-12">
                            <div className="dashboard-opbitem-sitecnt">
                                <OpbItem selectedOffice={selectedOffice} siteCnt={siteCnt} />
                                <SiteCntMng opbSiteCnt={opbSiteCnt} handleSelectedSiteID={this.handleSelectedSiteID} />
                            </div>
                        </div>

                        {/* 지도 */}
                        <div className="col col-lg-5 col-12">
                            <MapContent selectedOffice={selectedOffice} handleSelectedSiteID={this.handleSelectedSiteID} />
                        </div>

                        {/* Display현황 */}
                        <div className="col col-lg-3 col-12">
                            <OpbStats selectedSiteID={selectedSiteID} />
                        </div>
                    </div>
                    :
                    <div>
                        <div className="text-align-center">
                            <Loader
                                type="Rings"
                                color="#00BFFF"
                                height={'50%'}
                                width={'50%'}
                            />
                        </div>
                    </div>
                }
            </>
        );
    }
}


function mapState(state) {
    const { alert, userinfo } = state;
    const myInfo = userinfo.item;
    return { alert, myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
}

export default connect(mapState, actionCreators)(Dashboard);